import merge from 'lodash/merge'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { i18n } from '@/main'

class StringUtils {
  ellipsis (str, maxLength) {
    return str.length > maxLength ? str.substring(0, maxLength - 3) + '...' : str
  }

  updateLocaleMessages (langOverride) {
    let langOverrideJson
    try {
      langOverrideJson = JSON.parse(langOverride)
    } catch {
      return
    }

    if (isEmpty(langOverrideJson)) return

    const currentLocaleMessages = get(i18n.messages, i18n.locale, {})
    const overrideLocaleMessages = merge(currentLocaleMessages, langOverrideJson)

    i18n.setLocaleMessage(i18n.locale, overrideLocaleMessages)
  }
}

export default new StringUtils()
